export default __webpack_public_path__ + "assets/gh-video-placeholder.b8d6adc8.jpg";